import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53f45aa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "thanks" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle fa-fw" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "発注いただきありがとうございます。", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "発注確認メールを送信しましたので、ご確認ください。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode("発注を承りました。")
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("p", null, "発注番号は、" + _toDisplayString(_ctx.$route.query.order_id) + "です。", 1),
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/hist" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  icon: "el-icon-s-order"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("発注管理")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/map" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  icon: "el-icon-map-location"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("エリア選択")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}